import { lazy as loadable } from '@loadable/component'

import { createBrandedComponent } from '../create-branded-component'

const BRANDED_COMPONENTS = {
  playboom: loadable(() => import('./progress-bar-boom')),
  playboom24: loadable(() => import('./progress-bar-boom')),
  freedomcasino: loadable(() => import('./progress-bar-boom')),
  wettenlive: loadable(() => import('./progress-bar-boom')),
  casinosky: loadable(() => import('./progress-bar-boom')),
  casinoskyjp: loadable(() => import('./progress-bar-boom')),
  paradiseplay: loadable(() => import('./progress-bar-boom')),
}

export const ProgressBar = createBrandedComponent(
  'ProgressBar',
  BRANDED_COMPONENTS
)
